import { withAntComponent } from "../../hoc/withAntComponent";
import { Input as AntInput } from "antd";
import styled from "styled-components";

const StyledAntInput = styled(AntInput)`
    &.ant-input {
        border-color: ${({ theme: { colors } }) => colors.primary};
        border-radius: 8px;
        color: ${({ theme: { colors } }) => colors.secondary};
        height: 40px;

        &:focus,
        &:hover,
        &:active {
            border-color: ${({ theme: { colors } }) => colors.secondary};
        }
    }
`;

const Input = withAntComponent(StyledAntInput);
export default Input;
